import { For, Show, Suspense, createEffect, createResource, createSignal, onMount } from "solid-js";
import STButton from "../st-button/st-button";
import STModal from "../st-modal/st-modal";
import { requireReportBrowser } from "./report-browser-context";
import { reportBrowser as api } from 'st-app/api'
import { JobQueueRunInfo } from "st-app/api";
import './report-thumbnail-dialog.css'

export default function ReportThumbnailDialog() {
    const reportBrowser = requireReportBrowser()!
    const [isOpen, setIsOpen] = createSignal(reportBrowser.state.isThumbnailDialogOpen)
    const [newThumbnailFile, setNewThumbnailFile] = createSignal<File | undefined>()



    createEffect(() => { setIsOpen(reportBrowser.state.isThumbnailDialogOpen) })

    createEffect(() => {
        if (isOpen() !== reportBrowser.state.isThumbnailDialogOpen) {
            if (isOpen() === false) {
                reportBrowser.cancelCopy()
            }
        }
    })

    const onFileChange = (e: Event & { target: HTMLInputElement }) => {
        if (e.target.files) {
            const file = e.target.files[0]
            if (file) {
                setNewThumbnailFile(() => file)
            }
        }
    }

    const save = () => {
        reportBrowser.updateReportThumbnail(reportBrowser.selectedReport()!, newThumbnailFile()!)
    }

    const [previousJobs] = createResource(() => reportBrowser.state.selectedReportId, async (reportGu) => {
        return await api.LoadPreviousRuns(reportGu)
    })

    const updateImageFromJob = async (j: JobQueueRunInfo) => {
        if (!reportBrowser.state.selectedReportId) return
        if (!j.imgBase64) return

        reportBrowser.setReportThumbnail(reportBrowser.state.selectedReportId, j.imgBase64, 'png')
    }

    return (
        <Show when={reportBrowser.selectedReport()}>
            <STModal title="Report Thumbnail" show={[isOpen, setIsOpen]}>
                <div class="report-thumbnail-dialog">
                    <div class="report-thumbnail-dialog--heading">Choose File</div>
                    <div class="report-thumbnail-dialog--file-picker">
                        <input type="file" onChange={onFileChange}></input>
                        <STButton onClick={save} >
                            Update Thumbnail
                        </STButton>
                    </div>

                    <div class="report-thumbnail-dialog--divider"></div>

                    <div class="report-thumbnail-dialog--heading">Choose From Previous Runs</div>

                    <Suspense fallback={<span>Loading...</span>}>
                        <div class="report-thumbnail-dialog--jq-picker">
                            <For each={previousJobs()}>{(j) => (
                                <div class="report-thumbnail-dialog--jq-preview">
                                    <img role="button" tabindex="0" src={`data:image/png;base64,${j.imgBase64}`} onClick={() => updateImageFromJob(j)}></img>
                                    <span class="report-thumbnail-dialog--submit-dt">{j.submitDate?.substring(0, j.submitDate.length - 3)}</span>
                                </div>
                            )}</For>
                        </div>
                    </Suspense>
                </div>
            </STModal>
        </Show>
    );
}
